import { AgreeTerms } from '../../components/service/accounts/PrivacyTerms/AgreeTerms';
import { usePrivacyData, useTermsData } from '../../services';
export const AgreeTermsPageView = () => {
  const terms = useTermsData();
  const privacy = usePrivacyData();
  if (!terms.isSuccess || !privacy.isSuccess) {
    return <></>;
  }
  return <AgreeTerms privacyData={privacy.data} termsData={terms.data} data-sentry-element="AgreeTerms" data-sentry-component="AgreeTermsPageView" data-sentry-source-file="agree-terms.tsx" />;
};